import { Box, Typography } from '@material-ui/core';
import React, { Fragment } from 'react';
import { CostUnit, displayCost } from 'utilities/currencyFormatter';
import { getTotalEstimateAmount } from './utils';

const SelectionsCostBar = (props) => {
    const total = getTotalEstimateAmount(
        props.benefits, props.savedBenefits, props.topLevelInputFive,
        props.topLevelInputSix, props.topLevelInputSeven, props.topLevelInputEight,
        props.topLevelInputNine, props.avgHomesalePrice, props.avgHomesalePriceOrigin,
        props.applyTaxGrossUp, props.getOptionCost, props.grossUpPercentage
    );

    return (
      <Fragment>
        <Box position="relative" width="100%">
            <Typography sx={{ color: '#4d8766'}} color="primary" variant="h5">
                Estimate: {displayCost(total, CostUnit.CURRENCY)}
            </Typography>
        </Box>
      </Fragment>
    );
  };

export default SelectionsCostBar;
